import { save, openWhatsapp, getMeta, isDesktop, getMessage } from '../store.js';
import axios from 'axios';

(($) => {

    // For Ajax 
    async function handleFormSubmission( object, form ) {

        console.log('handleFormSubmission', object, form);
        

        const formId = form.querySelector('input[name="form_id"]').value || null

        if (!formId) return;

        // Make a Ajax request to the server.
        const rest = await axios.post(formychat_vars.ajax_url + '?action=formychat_get_formidable_entry&nonce=' + formychat_vars.nonce + '&form_id=' + formId);
        const result = rest.data.data || {};
        
        const widget = document.querySelector('[data-whatsapp]');
        // console.log('widget', widget);
        

        if (widget ) {

            // Inside widget.
            const widgetId = widget.dataset.widget;
            if (!widgetId) return;
 
            const widgetObject = formychat_vars.data.widgets.find(widget => widget.id == widgetId);
            if ( !widgetObject ) return;

            const whatsappNumber = widget.dataset.whatsapp;
            const { new_tab, web_version, formidable_message_template } = widgetObject.config.whatsapp || {};
            const message = getMessage(formidable_message_template, result.inputs);
            
            const data = {
                form: 'formidable',
                form_id: formId,
                field: result.inputs,
                meta: getMeta.value,
                widget_id: widgetId,
            }
            
            try {
                window.parent.postMessage({formychat_submitted: JSON.parse(JSON.stringify(data))}, '*');
            } catch (err) {
            }

            save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
            openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);

        } else {

            const whatsappNumber = result.formychat.number || '';
            const { new_tab, web_version, formidable_message_template } = result.formychat || {};
            const message = getMessage(formidable_message_template, result.inputs);

            const data = {
                form: 'formidable',
                form_id: formId,
                field: result.inputs,
                meta: getMeta.value,
                widget_id: null,
            }   

            save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
            openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);

        }
    }

    $(document).on('frmFormComplete', handleFormSubmission)


    // For Non-ajax forms.
    window.formychat_formidable_submit = (object) => {

        console.log('object', object);
        
        const widget = document.querySelector('[data-whatsapp]');
        
        if ( widget ) {
            const widgetId = widget.dataset.widget;
            if (!widgetId) return;
 
            const widgetObject = formychat_vars.data.widgets.find(widget => widget.id == widgetId);
            if ( !widgetObject ) return;

            const { new_tab, web_version, formidable_message_template } = widgetObject.config.whatsapp || {};
            const whatsappNumber = widget.dataset.whatsapp;
            const message = getMessage(formidable_message_template, object.inputs);

            const data = {
                form: 'formidable',
                form_id: object.form_id,
                field: object.inputs,
                meta: getMeta.value,
                widget_id: widgetId,
            }

            try {
                console.log('data', data);
                console.log('object', object);
                window.parent.postMessage({formychat_submitted: JSON.parse(JSON.stringify(data))}, '*');
            } catch (err) {
                console.log('error', err);
            }
            

            save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
            openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);

        } else {

            const settings = object.formychat || {};
            if ( !settings || !settings.status ) return;
            const { number, message, new_tab, web_version } = settings;
            const formidableMessage = getMessage(message, object.inputs);

            
            const data = {
                form: 'formidable',
                form_id: object.form_id,
                field: object.inputs,
                meta: getMeta.value,
                widget_id: null,
            }

            save(data, number, formidableMessage, isDesktop() && web_version == 1, new_tab == 1);
            openWhatsapp(number, formidableMessage, isDesktop() && web_version == 1, new_tab == 1);

        } 
    }

    // Trigger custom event that formychat_formidable_loaded
    const event = new CustomEvent('formychat_formidable_loaded', {
        detail: {
            formychat_formidable_loaded: true
        }
    });
    document.dispatchEvent(event);

})(jQuery)
